import React from "react";
import useDate from "../../../../../../hooks/app/useDate";
import TextEllipsis from "../../../../../text/TextEllipsis";
import ElementsFromTo from "./ElementsFromTo";

const LogCardMin = ({
  log = {}
}) => {
  const { formatDate } = useDate();

  return (
    <div
      className={[
        "border border-muted rounded py-2 px-2 relative min-w-300px",
      ].join(" ")}
      style={{ maxWidth: "410px" }}
    >
      <div>
        {Object.keys(log?.lcElements || {}).map((key) => (
          <TextEllipsis
            key={key}
            className="text-sm text-primary font-bold "
            children={log?.lcElements[key]}
          />
        ))}
        <p className="text-xs font-bold text-secondary mt-2">
          Changes:
        </p>
        <ElementsFromTo
          from={log.from}
          to={log.to}
        />
        <div className="text-right text-muted-foreground opacity-75 mt-2">
          <span className="text-xs ">Marked on </span>
          <b className="text-xs ">{formatDate(log.date, " dd/MM/yyyy")}</b>{" "}
          <span className="text-xs ">
            {log.type === "close" ? "closed " : ""} by{" "}
          </span>{" "}
          <b className="text-xs ">{log.userName || log.userCode}</b>
        </div>
      </div>
    </div>
  );
};

export default LogCardMin;
